var Curriculog = Curriculog || {};

Curriculog.ManageEntityView = (function ($, _, Backbone, ManageEntityView) {
	ManageEntityView = Curriculog.CurriculogView.extend({
		template: 'HierarchyFlyout/manageEntity.html',
		events: {
			'click #entity-details-update': 'validateEntity',
			'click #entity-details-delete': 'deleteEntity',
			'click #entity-details-reset': 'resetForm',
		},
		initialize: function (options) {
			this.roles = options.roles;
			this.entities = options.entities;
			this.entityTypes = options.entityTypes;
			this.entityCanDelete = options.entityCanDelete;
			this.relationships = options.relationships;
			this.currentEntityID = options.currentEntityID;
			this.entity = this.entities.get(this.currentEntityID);
			this.listenTo(this.roles, 'new-role', this.newRole);
			this.listenTo(this.roles, 'delete-role', this.deleteRole);
			this.render();
		},


		render: function () {
			templateData = {
				entityTypes: this.entityTypes.toJSON(),
				entity: this.entity.toJSON(),
			};

			var el = nunjucks.render(this.template, templateData);
			this.replaceElement(el);
			this.renderDropdown();

			if (this.entityCanDelete) {
				this.$el.find('#entity-details-delete').prop('disabled', false);
			}
		},

		renderDropdown: function () {
			var subView = new Curriculog.DropdownView({
				collection: this.entityTypes,
				id: 'entity-details-type'
			});

			var entityTypeID = this.entity.get('entity_type_id');
			var entityTypeLabel = $(this.$el).find('label')[1];

			$(subView.el).find('[value="' + entityTypeID + '"]').prop('selected', true);
			$(subView.el).insertAfter(entityTypeLabel);
			this.entityTypeDropdown = subView;
		},

		getNewValues: function () {
			var changes = {}

			if ($('#entity-details-status').prop('checked')) {
				changes['status'] = 'active';
			} else {
				changes['status'] = 'inactive';
			}

			var entityTypeID = this.entityTypeDropdown.getCurrentSelection();
			changes['entity_type_id'] = parseInt(entityTypeID);

			var name = $('#entity-details-name').val();
			changes['name'] = name;

			return changes;
		},

		removeErrors: function () {
			var errorMessages = this.$el.find('#entity-details-form > span.error');

			for (var i = 0; i < errorMessages.length; i++) {
				errorMessages[i].remove();
			}
		},

		validateEntity: function () {
			modelChanges = this.getNewValues();

			if (modelChanges['name'].trim().length <= 0) {
				var errorMessages = this.$el.find('#entity-details-form > span.error');
				if (errorMessages.length <= 0) {
					var element = '<span for="entity-name" class="error">This field is required.</span>';
					$(element).insertAfter('#entity-details-name');
				}

				this.$el.find('#entity-details-name').val('');
			} else {
				this.removeErrors();
				this.updateEntity(modelChanges);
			}
		},

		updateEntity: function(modelChanges) {
			var view = this;
			var oldEntityTypeID = this.entity.get('entity_type_id')
			if (modelChanges.name.trim().length > 0) {
				this.entity.save(modelChanges, {
					wait: true,

					success: function () {
						if (oldEntityTypeID) {
							var oldEntityType = view.entityTypes.get(oldEntityTypeID);
							var entitiesUsingOldEntityType = view.entities.getEntitiesByEntityType(oldEntityTypeID);

							// reset old entity type's canDelete
							if (entitiesUsingOldEntityType.length > 0) {
								oldEntityType.set('canDelete', false);
							} else {
								oldEntityType.set('canDelete', true);
							}
						}

						// set new entity type's canDelete to false
						entityType = view.entityTypes.get(view.entity.get('entity_type_id'));
						if (entityType) {
							entityType.set('canDelete', false);
						} else {
							var msg = "This entity was saved but it does not have an entity type."
							new Curriculog.SimpleWarningDialog({message: msg});
						}

						Curriculog.Actions.log('entity-update-success');
					},

					error: function(result) {
						view.resetForm();

						var errorText = 'An error was encountered when updating the entity.  ';
						errorText += 'The entity has not been updated.  Please try again ';
						errorText += 'or contact an administrator.';
						view.showGrowl(errorText);
					},
				});
			}
		},

		deleteEntity: function () {
			var view = this;
			var entityTypeID = this.entity.get('entity_type_id');
			var entityID = this.entity.get('id');

			new Curriculog.DeleteDialog({
				itemType: 'entity',
				itemName: view.entity.getSanitizedModel().get('name'),
				callback: function () {

					view.entity.destroy({
						wait: true,

						success: function () {
							view.relationships.removeAllRelationships(entityID);
							if (entityTypeID > 0 && view.entities.getEntitiesByEntityType(entityTypeID).length === 0) {
								var entityType = view.entityTypes.get(entityTypeID);
								entityType.set('canDelete', true);
							}

							closeFlyout();
						},

						error: function () {
							var errorText = 'An error was encountered when deleting the entity.  ';
							errorText += 'The entity has not been deleted.  Please try again '
							errorText += 'or contact an administrator.';
							$('#growls').notify('create', 'warning-template', {
								text: errorText
							});
						},
					});
				},
			});
		},

		resetForm: function () {
			this.render();
		},

		newRole: function (role) {
			if (role.get('entity_id') === this.entity.get('id')) {
				this.$el.find('#entity-details-delete').attr('disabled', 'disabled');
			}
		},

		deleteRole: function (event) {
			var view = this;
			$.ajax({
				type: 'GET',
				url: 'rest/entitycandelete/' + view.entity.get('id'),

				error: function() {

				},

				success: function (data) {
					if (data.entity_can_delete) {
						view.$el.find('#entity-details-delete').prop('disabled', false);
					} else {
						view.$el.find('#entity-details-delete').attr('disabled', 'disabled');
					}
				},
			});
		},
	});
	return ManageEntityView

})($, _, Backbone, Curriculog.ManageEntityView || {});
